import { fabric } from 'fabric';

import { InternalCanvas } from '../canvas';
import { DrawingTool, ObjectBuilder, UpdateObjectRect } from './tool';

class LineBuilder extends ObjectBuilder<fabric.Line> {
    constructor(canvas: InternalCanvas, initialPoint: fabric.Point) {
        super(
            initialPoint,
            new fabric.Line(
                [
                    initialPoint.x,
                    initialPoint.y,
                    initialPoint.x,
                    initialPoint.y,
                ],
                {
                    strokeWidth: canvas.brushWidth,
                    stroke: canvas.brushColor,
                },
            ),
        );
    }

    protected _updateObject({ x1, y1, x2, y2 }: UpdateObjectRect): void {
        this._object.set({ x1, y1, x2, y2 });
    }
}

export class LineTool extends DrawingTool {
    public createObjectBuilder(
        canvas: InternalCanvas,
        initialPoint: fabric.Point,
    ): LineBuilder {
        return new LineBuilder(canvas, initialPoint);
    }
}
